import * as React from "react";
import { useMediaQuery } from "@mui/material";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import Button from "components/Button";

import { routes } from "routes/routes";

import Hotels from "assets/images/landing/hotels.jpg";
import Beauty from "assets/images/landing/beauty.jpg";
import AutoService from "assets/images/landing/auto-service.jpg";
import OnlineSales from "assets/images/landing/online-sales.jpg";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

const businesses = [
  {
    title: "Автосервіси",
    image: AutoService,
    route: routes.sip + routes.autoService,
  },
  {
    title: "Онлайн продажі",
    image: OnlineSales,
    route: routes.sip + routes.onlineSales,
  },
  {
    title: "Готелі",
    image: Hotels,
    route: routes.sip + routes.hotels,
  },
  {
    title: "Салони краси",
    image: Beauty,
    route: routes.sip + routes.beauty,
  },
];

const Businesses: React.FC = () => {
  const showShortenedText = useMediaQuery(
    "(min-width:900px) and (max-width:1050px)",
  );

  const onBusinessClick = (route: string) => {
    analytics().sendConversionEvent(
      AnalyticsEvents.iban_oplata_bussiness_ + route,
      null,
      true,
    );
    window.location.href = route;
  };

  return (
    <Container sx={styles.businessesBlock}>
      <Box>
        <Typography variant="subtitle1" color="error.dark">
          Оплата за реквізитами IBAN в один клік
        </Typography>
        <Typography variant="h2" sx={{ whiteSpace: "pre-line", mt: 2, mb: 6 }}>
          <Typography variant="h2" color="primary" sx={{ display: "inline" }}>
            IBAN oplata
          </Typography>{" "}
          для всіх типів бізнесу
        </Typography>
      </Box>
      <Box sx={styles.businessesWrapper}>
        {businesses.map((business, index) => (
          <Box
            key={index}
            sx={{
              ...styles.business,
              backgroundImage: `linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.1)), url(${business.image})`,
            }}
          >
            <Stack sx={styles.cardContent}>
              <Typography
                variant="h3"
                color="white"
                fontWeight={700}
                sx={{ textShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)" }}
              >
                {business.title}
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => onBusinessClick(business.route)}
              >
                {showShortenedText ? "Детальніше" : "Дізнатись більше"}
              </Button>
            </Stack>
          </Box>
        ))}
      </Box>
    </Container>
  );
};

const styles = {
  businessesBlock: {
    textAlign: "center",
    paddingTop: { xs: "56px", sm: "120px" },
    paddingBottom: { xs: "56px" },
  },
  businessesWrapper: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: { xs: "center", md: "space-between" },
    alignItems: { xs: "center", md: "stretch" },
    gap: 2.5,
  },
  business: {
    position: "relative",
    display: "flex",
    width: "100%",
    height: "360px",
    borderRadius: "20px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: 2.5,
    color: "white",
  },
  cardContent: {
    flexGrow: 1,
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
};

export default Businesses;
